"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckSupplier = void 0;
class CheckSupplier {
    static isRaflatac(kontrahent_id) {
        const kontrahentStr = kontrahent_id.toString();
        const supplier = this.ids[kontrahentStr];
        return supplier?.toUpperCase().includes("RAFLATAC") ?? false;
    }
    static getRaflatacIDs() {
        return Object.entries(this.ids)
            .filter(([_, name]) => name.toUpperCase().includes("RAFLATAC"))
            .map(([id]) => Number(id));
    }
    static getAveryIDs() {
        return Object.entries(this.ids)
            .filter(([_, name]) => name.includes("AVERY"))
            .map(([id]) => Number(id));
    }
    static isAvery(kontrahent_id) {
        const kontrahentStr = kontrahent_id.toString();
        const supplier = this.ids[kontrahentStr];
        return supplier === "AVERY";
    }
}
exports.CheckSupplier = CheckSupplier;
CheckSupplier.ids = {
    "241": "AVERY",
    "2782": "UPM_Raflatac_Oy",
    "6722": "UPM_Raflatac_Fi",
    "6723": "UPM_Raflatac_Fr",
    "234": "FLINT_GROUP"
};
